import { render } from "./WizardView.vue?vue&type=template&id=5054161c&scoped=true"
import script from "./WizardView.vue?vue&type=script&lang=js"
export * from "./WizardView.vue?vue&type=script&lang=js"

import "./WizardView.vue?vue&type=style&index=0&id=5054161c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5054161c"]])

export default __exports__